import React from 'react';
import {
    withRouter,
    Link
} from 'react-router-dom';
import {Tabs, Tab} from './Tabs'
import SidebarNavigation from './SidebarNavigation'
import {AddNewNodebook, PreviewNodebook} from './PreviewNodebook'
import constants from '../ndbk-constants'
import Toggler from './Toggler'
import PermissionsManager from './PermissionsManager'
import NotFoundPage from '../pages/NotFoundPage';
import {
    Button,
    AnchorButton
} from "@blueprintjs/core";

class GroupPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            users : [],
            nodebooks : [],
            info: {
                avatar: "",
                description: "",
                following: 0,
                name: "",
                visibility: "",
                followers: 0,
                description: ""
            },
            activities: [],
            addMemberInput : "",
            isEdit: false,
            oldInfo: {},
            userSearchResults: []
        }
    }

    componentWillMount() {
        this.fetchGroup()
        this.fetchNodebooks()
        this.fetchMembers()
        // this.fetchActivities()
    }

    fetchActivities = (isUser) => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/activities`, {
                method: 'GET',
                credentials: 'include',
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({activities: response.data})
                    }
                    return response.success;
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    followGroup = () => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.state.info.id}/subscribe`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({info:{...this.state.info, isFollowing: true, followers: (this.state.info.followers+1)}})
                    }
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    unfollowGroup = () => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.state.info.id}/unsubscribe`, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({info:{...this.state.info, isFollowing: false, followers: (this.state.info.followers-1)}})
                    }
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    fetchMembers = () => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/users`, {
                method: 'GET',
                credentials: 'include',
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({users: response.data});
                    } else {
                        this.setState({errCode: response.code})
                    }
                    return response.success;
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    fetchNodebooks = () => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/nodebooks`, {
                method: 'GET',
                credentials: 'include',
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({nodebooks: response.data});
                    }
                    return response.success;
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    fetchGroup = () => {
        fetch(`https://${constants.SERVER_IP}/api/group/`+this.props.match.params.id, {
            method: 'GET',
            credentials: 'include',
        })
        .then((response) => response.json())
        .then((response) => {
                if (response.success) {
                    this.setState({info: response.data})
                    document.title = `${response.data.name} - ` + constants.WEBSITE_TITLE
                }
                return response.success;
            })
        .catch((error) => {
                console.error(error);
        });
    }

    updateGroup = (data) => {
        fetch(`https://${constants.SERVER_IP}/api/group/`+this.props.match.params.id+`/update`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                data
                // {
                //     name: this.state.info.name,
                //     description: this.state.info.description,
                //     visibility: this.state.info.visibility
                // }
            )
        })
        .then((response) => response.json())
        .then((response) => {
                return response.success;
            })
        .catch((error) => {
                console.error(error)
        })
    }

    deleteGroup = (id) => {
        fetch(`https://${constants.SERVER_IP}/api/group/${id}/delete`, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.props.history.push("/user/"+this.props.auth.user.username+"/groups")
                    }
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    updateMember = (id, permissions) => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/user/${id}/update/`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({permissions:permissions})
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.success) {
                this.fetchMembers()
            }
            })
        .catch((error) => {
                console.error(error);
        });
    }

    leaveGroup = () => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/leave/`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((response) => {
                if (response.success) {
                    this.setState({info:{...this.state.info, permissions: 'none' }})
                }
            })
        .catch((error) => {
                console.error(error);
        });
    }

    deleteMember = (id) => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/user/${id}/delete/`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((response) => {
                if (response.success) {
                    this.fetchMembers()
                }
            })
        .catch((error) => {
                console.error(error);
        });
    }

    addMember = (id) => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/user/${id}/add/`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((response) => {
                if (response.success) {
                    this.setState({addMemberInput:'', userSearchResults:[]})
                    this.fetchMembers()
                }
            })
        .catch((error) => {
                console.error(error);
        });
    }

    onFileInput = (files) => {
		var file=files[0]
		const reader = new FileReader();
            reader.onload = () => {
                //const fileAsBinaryString = reader.result;
                        var formData = new FormData();
                        formData.append('profile_image', file)
                        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/upload_group_profile_picture`, {
                            method: 'POST',
                            body: formData,
                            credentials: 'include',
                        })
                            .then((response)=>response.json())
                            .then((response)=>{
                                if (response.success) {
									this.fetchGroup();
								}
                            })
                            .catch((err)=>
                            {
                            })
            };
            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => console.log('file reading has failed');
            try {
                reader.readAsBinaryString(file);
            } catch (err) {
                console.log(err)
            }
    }

    onAddMemberInputChange = (e) => {
        let text = e.target.value;
        if (text.length > 2) {
            this.setState({addMemberInput:text})
            fetch(`https://${constants.SERVER_IP}/api/search/users/${text}`, {
                            method: 'GET',
                            credentials: 'include',
                        })
                            .then((response)=>response.json())
                            .then((response)=>{
                                if (response.success) {
                                    this.setState({userSearchResults:response.data})
								}
                            })
                            .catch((err)=>
                            {
                            })
        } else {
            this.setState({addMemberInput:text, userSearchResults:[]})
        }
    }

    createNodebook = () => {
        fetch(`https://${constants.SERVER_IP}/api/group/${this.props.match.params.id}/nodebook_create`,
                {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title: 'New nodebook',
                    description: 'Description',
                    visibility: 'public',
                    //templates: this.state.templates.filter((value, id)=>value.selected===true).map((value, id)=>value.id)
                })
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.props.history.push(`/nodebook/${response.data.id}`);
                    }
                    return response.success;
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    render() {
        var stats = null
        stats = <div className="header-card-content-stats">
                    <div className="header-card-content-stats-block">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#382371" d="M10 12c-0.066 0-0.132-0.013-0.194-0.039l-9.5-4c-0.185-0.078-0.306-0.26-0.306-0.461s0.121-0.383 0.306-0.461l9.5-4c0.124-0.052 0.264-0.052 0.388 0l9.5 4c0.185 0.078 0.306 0.26 0.306 0.461s-0.121 0.383-0.306 0.461l-9.5 4c-0.062 0.026-0.128 0.039-0.194 0.039zM1.788 7.5l8.212 3.457 8.212-3.457-8.212-3.457-8.212 3.457z"></path><path fill="#382371" d="M10 15c-0.066 0-0.132-0.013-0.194-0.039l-9.5-4c-0.254-0.107-0.374-0.4-0.267-0.655s0.4-0.374 0.655-0.267l9.306 3.918 9.306-3.918c0.254-0.107 0.548 0.012 0.655 0.267s-0.012 0.548-0.267 0.655l-9.5 4c-0.062 0.026-0.128 0.039-0.194 0.039z"></path><path fill="#382371" d="M10 18c-0.066 0-0.132-0.013-0.194-0.039l-9.5-4c-0.254-0.107-0.374-0.4-0.267-0.655s0.4-0.374 0.655-0.267l9.306 3.918 9.306-3.918c0.254-0.107 0.548 0.012 0.655 0.267s-0.012 0.548-0.267 0.655l-9.5 4c-0.062 0.026-0.128 0.039-0.194 0.039z"></path></svg>
                        <span>
                            {this.state.nodebooks.length} nodebooks
                        </span>
                    </div>
                    <div className="header-card-content-stats-block">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#382371" d="M1.5 19c-0.276 0-0.5-0.224-0.5-0.5v-15c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v15c0 0.276-0.224 0.5-0.5 0.5z"></path>
                            <path fill="#382371" d="M3.5 10c-0.104 0-0.21-0.033-0.3-0.1-0.221-0.166-0.266-0.479-0.1-0.7 0.067-0.090 1.676-2.2 3.9-2.2 1.694 0 2.813 0.599 3.801 1.127 0.875 0.468 1.631 0.873 2.699 0.873 2.192 0 3.758-2.080 4.65-3.718-0.698 0.397-1.59 0.718-2.65 0.718-2.207 0-3.347-1.14-4.354-2.146-0.995-0.995-1.854-1.854-3.646-1.854-2.224 0-3.587 1.782-3.6 1.8-0.166 0.221-0.479 0.266-0.7 0.1s-0.266-0.479-0.1-0.7c0.067-0.090 1.681-2.2 4.4-2.2 2.207 0 3.347 1.14 4.354 2.146 0.995 0.995 1.854 1.854 3.646 1.854 2.224 0 3.587-1.782 3.6-1.8 0.147-0.196 0.415-0.257 0.632-0.143s0.32 0.368 0.242 0.601c-0.021 0.064-0.533 1.581-1.558 3.119-0.612 0.918-1.282 1.653-1.991 2.185-0.918 0.688-1.902 1.037-2.925 1.037-1.318 0-2.26-0.504-3.171-0.991-0.97-0.519-1.886-1.009-3.329-1.009-1.73 0-3.087 1.782-3.1 1.8-0.098 0.131-0.248 0.2-0.4 0.2z"></path>
                        </svg>
                        <span>{this.state.info.followers} followers</span>
                    </div>
                    <div className="header-card-content-stats-block">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#382371" d="M18.916 11.208c0.443-0.511 0.695-1.355 0.695-2.159 0-0.531-0.115-0.996-0.333-1.345-0.284-0.454-0.738-0.704-1.278-0.704h-2.618c1.425-2.591 1.785-4.543 1.070-5.807-0.499-0.881-1.413-1.193-2.045-1.193-0.25 0-0.462 0.185-0.495 0.433-0.179 1.319-1.188 2.893-2.768 4.318-1.514 1.365-3.374 2.456-5.286 3.11-0.241-0.508-0.758-0.86-1.356-0.86h-3c-0.827 0-1.5 0.673-1.5 1.5v9c0 0.827 0.673 1.5 1.5 1.5h3c0.634 0 1.176-0.395 1.396-0.952 1.961 0.246 2.699 0.64 3.414 1.022 0.895 0.478 1.739 0.93 4.503 0.93 0.72 0 1.398-0.188 1.91-0.529 0.5-0.333 0.82-0.801 0.926-1.343 0.399-0.162 0.753-0.536 1.024-1.092 0.264-0.541 0.435-1.232 0.435-1.761 0-0.099-0.006-0.19-0.017-0.274 0.253-0.186 0.48-0.473 0.667-0.851 0.27-0.545 0.432-1.228 0.432-1.826 0-0.424-0.079-0.777-0.234-1.051-0.013-0.022-0.026-0.044-0.039-0.065zM4.5 18h-3c-0.276 0-0.5-0.224-0.5-0.5v-9c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v8.999c0 0 0 0.001 0 0.001-0 0.276-0.224 0.5-0.5 0.5zM18.339 10.274c-0.151 0.304-0.304 0.414-0.37 0.414-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.042 0 0.072 0 0.117 0.078 0.066 0.117 0.104 0.32 0.104 0.558 0 0.445-0.126 0.974-0.328 1.382-0.198 0.399-0.399 0.544-0.487 0.544-0.276 0-0.5 0.224-0.5 0.5 0 0.177 0.092 0.333 0.231 0.422 0.031 0.317-0.117 1.165-0.501 1.718-0.145 0.209-0.298 0.329-0.418 0.329-0.276 0-0.5 0.224-0.5 0.5 0 0.88-0.972 1.281-1.875 1.281-2.513 0-3.217-0.376-4.032-0.812-0.762-0.407-1.618-0.865-3.781-1.134v-8.187c2.101-0.689 4.152-1.877 5.812-3.373 1.593-1.436 2.639-2.988 2.994-4.426 0.272 0.087 0.579 0.271 0.776 0.618 0.334 0.59 0.584 2.096-1.493 5.557-0.093 0.154-0.095 0.347-0.006 0.504s0.255 0.254 0.435 0.254h3.483c0.199 0 0.327 0.070 0.43 0.234 0.117 0.187 0.181 0.477 0.181 0.815 0 0.424-0.102 0.882-0.272 1.225z"></path></svg>
                        <span>{this.state.info.likes} likes</span>
                    </div>
                    <div className="header-card-content-stats-block">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#382371" d="M19.872 10.166c-0.047-0.053-1.182-1.305-2.956-2.572-1.047-0.748-2.1-1.344-3.13-1.773-1.305-0.544-2.579-0.82-3.786-0.82s-2.481 0.276-3.786 0.82c-1.030 0.429-2.083 1.026-3.13 1.773-1.774 1.267-2.909 2.52-2.956 2.572-0.171 0.19-0.171 0.479 0 0.669 0.047 0.053 1.182 1.305 2.956 2.572 1.047 0.748 2.1 1.344 3.13 1.773 1.305 0.544 2.579 0.82 3.786 0.82s2.481-0.276 3.786-0.82c1.030-0.429 2.083-1.026 3.13-1.773 1.774-1.267 2.909-2.52 2.956-2.572 0.171-0.19 0.171-0.479 0-0.669zM12.574 6.438c0.907 0.763 1.426 1.873 1.426 3.062 0 2.206-1.794 4-4 4s-4-1.794-4-4c0-1.188 0.519-2.299 1.426-3.062 0.822-0.268 1.691-0.438 2.574-0.438s1.752 0.17 2.574 0.438zM16.317 12.606c-1.533 1.092-3.873 2.394-6.317 2.394s-4.784-1.302-6.317-2.394c-1.157-0.824-2.042-1.658-2.489-2.106 0.447-0.448 1.332-1.281 2.489-2.106 0.53-0.378 1.156-0.78 1.85-1.145-0.347 0.688-0.533 1.455-0.533 2.251 0 2.757 2.243 5 5 5s5-2.243 5-5c0-0.796-0.186-1.563-0.533-2.251 0.694 0.365 1.32 0.768 1.85 1.145 1.157 0.824 2.042 1.658 2.489 2.106-0.447 0.448-1.332 1.281-2.489 2.106z"></path></svg>
                        <span>{this.state.nodebooks.reduce((a,b)=>a+b.views,0)} views</span>
                    </div>
                </div>

        if (this.state.errCode === 403) {
            return <NotFoundPage title="403" message="Group is private"/>
        }

        if (this.state.errCode === 404) {
            return <NotFoundPage title="404" message="Group not found"/>
        }

        const authLevel = {
            // Use this for integer-based checking of permissions ( ex. permissions > 0 )
            'admin': 10,
            'editor': 5,
            'view': 1,
            'none': 0
        }

        var buttons = <div className="header-card-content-actions">
                        {/* {(this.state.info.isFollowing)?<a onClick={this.unfollowGroup}>Unfollow</a>:<a onClick={this.followGroup}>Follow</a>} */}
                        </div>
        if (this.state.info.permissions==='admin') {
            buttons =   <div className="header-card-content-actions">
                            {/*<Link to={`/group/${this.props.match.params.id}/new/nodebook`}>Add nodebook</Link>*/}
                            {/* <Link onClick={this.editGroup} to="#">Edit</Link> */}
                            {/* {(this.state.info.isFollowing)?<a onClick={this.unfollowGroup}>Unfollow</a>:<a onClick={this.followGroup}>Follow</a>} */}
                        </div>
        }
        // if (this.state.info.permissions==='admin' && this.state.isEdit) {
        //     buttons =   <div className="header-card-content-actions">
        //                     {/* <Link onClick={this.cancelEdit} to="#">Cancel</Link>
        //                     <Link onClick={this.updateGroup} to="#">Save</Link> */}
        //                 </div>
        // }
        if (this.state.info.permissions==='editor') {
            buttons =   <div className="header-card-content-actions">
                            {/* <Link to={`${this.props.match.params.id}/new/nodebook`}>Add nodebook</Link> */}
                            {/* {(this.state.info.isFollowing)?<a onClick={this.unfollowGroup}>Unfollow</a>:<a onClick={this.followGroup}>Follow</a>} */}
                            {/* <a href="">Leave group</a> */}
                        </div>
        }
        if (this.state.info.permissions==='view') {
            buttons =   <div className="header-card-content-actions">
                            {/* {(this.state.info.isFollowing)?<a onClick={this.unfollowGroup}>Unfollow</a>:<a onClick={this.followGroup}>Follow</a>} */}
                            {/* <a href="">Leave group</a> */}
                        </div>
        }

        var selectedTab = (['nodebooks', 'activity', 'members'].indexOf(this.props.match.params.tab) !== -1)?this.props.match.params.tab:'nodebooks';

        return (
            <div className="main">

                <SidebarNavigation {...this.props}/>

                <div className="main-content">

                    <div className="header-card">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-10">
                                <div className="header-card-avatar">
                                    <label className={"avatarpicker"+((this.state.info.permissions!=='admin')?' disabled':'')}>
                                        <img src={this.state.info.avatar} alt="Group icon"/>
                                        {
                                            (this.state.info.permissions==='admin')
                                                ? <input type="file" multiple={false} accept="image/*" onChange={(e) => this.onFileInput(e.target.files)} />
                                                : null
                                        }
                                    </label>
                                </div>
                                    <div className="header-card-content">
                                        <div
                                            title={(this.state.info.permissions !== 'admin')?"Group visibility":"Click to toggle visibility"}
                                            className={`visibility-${this.state.info.visibility} fixed ${(this.state.info.permissions!=='admin')?'disabled':''}`}
                                            onClick={(this.state.info.permissions!=='admin') ? null : ()=>{
                                                let newVisibility = (this.state.info.visibility === 'public') ? 'private' : 'public'
                                                this.setState({info: {...this.state.info, visibility: newVisibility}}, () => {
                                                    this.updateGroup({visibility:newVisibility})
                                                })
                                            }}
                                        >
                                            {this.state.info.visibility}
                                        </div>
                                        <input disabled={(this.state.info.permissions!=='admin')} spellCheck="false" className={"maininfo"} value={this.state.info.name}
                                            onChange={ (e) => {
                                                this.setState({info: {...this.state.info, name: e.target.value}}, ()=> {
                                                    this.updateGroup({name: this.state.info.name})
                                                })
                                            }}
                                        />
                                        <div className="header-card-content-actions">
                                            {/* follow/unfollow */}
                                            <Button
                                                icon="flag"
                                                text={this.state.info.isFollowing?"Unfollow":"Follow"}
                                                onClick={this.state.info.isFollowing?this.unfollowGroup:this.followGroup}
                                                style={{marginLeft: "10px"}}
                                            />
                                            {/* <span className={`checkbox ${(this.state.info.isFollowing)?'selected':''}`} onClick={this.state.info.isFollowing?this.unfollowGroup:this.followGroup} title={this.state.info.isFollowing?"Unfollow":"Follow"}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                                    <path d="M1.5 19c-0.276 0-0.5-0.224-0.5-0.5v-15c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v15c0 0.276-0.224 0.5-0.5 0.5z"></path>
                                                    <path d="M3.5 10c-0.104 0-0.21-0.033-0.3-0.1-0.221-0.166-0.266-0.479-0.1-0.7 0.067-0.090 1.676-2.2 3.9-2.2 1.694 0 2.813 0.599 3.801 1.127 0.875 0.468 1.631 0.873 2.699 0.873 2.192 0 3.758-2.080 4.65-3.718-0.698 0.397-1.59 0.718-2.65 0.718-2.207 0-3.347-1.14-4.354-2.146-0.995-0.995-1.854-1.854-3.646-1.854-2.224 0-3.587 1.782-3.6 1.8-0.166 0.221-0.479 0.266-0.7 0.1s-0.266-0.479-0.1-0.7c0.067-0.090 1.681-2.2 4.4-2.2 2.207 0 3.347 1.14 4.354 2.146 0.995 0.995 1.854 1.854 3.646 1.854 2.224 0 3.587-1.782 3.6-1.8 0.147-0.196 0.415-0.257 0.632-0.143s0.32 0.368 0.242 0.601c-0.021 0.064-0.533 1.581-1.558 3.119-0.612 0.918-1.282 1.653-1.991 2.185-0.918 0.688-1.902 1.037-2.925 1.037-1.318 0-2.26-0.504-3.171-0.991-0.97-0.519-1.886-1.009-3.329-1.009-1.73 0-3.087 1.782-3.1 1.8-0.098 0.131-0.248 0.2-0.4 0.2z"></path>
                                                </svg>
                                            </span> */}
                                        {/* delete */}
                                            {(this.state.info.permissions === 'admin')
                                                ? (
                                                    <Button
                                                        icon="trash"
                                                        text="Delete group"
                                                        onClick={()=>{this.deleteGroup(this.props.match.params.id)}}
                                                        style={{marginLeft: "10px"}}
                                                    />
                                                )
                                                : null
                                            }
                                            {/* leave */}
                                            {
                                                (this.state.info.permissions !== 'admin' && this.state.info.permissions !== 'none')
                                                ?<span
                                                className="nicebtn rightround nomargin"
                                                onClick={this.leaveGroup}
                                                title="Leave group">
                                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                                        <path fill="#000000" d="M11.5 8c0.276 0 0.5-0.224 0.5-0.5v-4c0-0.827-0.673-1.5-1.5-1.5h-9c-0.827 0-1.5 0.673-1.5 1.5v12c0 0.746 0.537 1.56 1.222 1.853l5.162 2.212c0.178 0.076 0.359 0.114 0.532 0.114 0.213-0 0.416-0.058 0.589-0.172 0.314-0.207 0.495-0.575 0.495-1.008v-1.5h2.5c0.827 0 1.5-0.673 1.5-1.5v-4c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5h-2.5v-9.5c0-0.746-0.537-1.56-1.222-1.853l-3.842-1.647h7.564c0.276 0 0.5 0.224 0.5 0.5v4c0 0.276 0.224 0.5 0.5 0.5zM6.384 5.566c0.322 0.138 0.616 0.584 0.616 0.934v12c0 0.104-0.028 0.162-0.045 0.173s-0.081 0.014-0.177-0.027l-5.162-2.212c-0.322-0.138-0.616-0.583-0.616-0.934v-12c0-0.079 0.018-0.153 0.051-0.22l5.333 2.286z"></path>
                                                        <path fill="#000000" d="M18.354 9.146l-3-3c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2.146 2.146h-6.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h6.293l-2.146 2.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l3-3c0.195-0.195 0.195-0.512 0-0.707z"></path>
                                                    </svg>
                                                    Leave
                                                </span>
                                                :<br/>
                                            }
                                    </div>

                                    <div className="header-card-content-text">
                                        <textarea disabled={(this.state.info.permissions!=='admin')} spellCheck="false" className={"maininfo"} value={this.state.info.description}
                                            placeholder={(this.state.info.permissions!=='admin'?'':'Write group description...')}
                                            onChange={ (e) => {
                                                this.setState({info: {...this.state.info, description: e.target.value}}, ()=> {
                                                    this.updateGroup({description: this.state.info.description})
                                                })
                                            }}
                                        />
                                    </div>

                                    <br/>
                                    {buttons}
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    {stats}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="header-card header-card-edit">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-9">
                                    <div className="header-card-avatar">
                                        <img src={this.state.info.avatar} style={{width:100, height:100}} alt=""/>
										<input type="file" multiple={false} accept= "image/*" onChange={ (e) => this.onFileInput(e.target.files) }/>
                                    </div>
                                    <div className="header-card-content">
                                        <div className="header-card-content-name-edit">
                                            <input type="text" placeholder="Group title" value={this.state.info.name} onChange={e=>this.setState({info: {...this.state.info, name: e.target.value }})} />
                                        </div>
                                        {buttons}
                                        <div className="header-card-content-text-edit">
                                        <textarea placeholder="Group description" value={this.state.info.description || ''} onChange={e=>this.setState({info: {...this.state.info, description: e.target.value }})} />
                                        <label>Visibility</label>
                                        <select value={this.state.info.visibility}  onChange={e=>this.setState({info: {...this.state.info, visibility: e.target.value }})}>
                                            <option value="private">Private</option>
                                            <option value="public">Public</option>
                                        </select>
                                        </div>
                                        <Link to={"/user/"+this.props.auth.user.username+"/groups"} onClick={()=>{this.deleteGroup(this.props.match.params.id)}}>Delete group</Link>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    {stats}
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <Tabs
                        selectedTab={selectedTab}
                        onChangeTab={selectedTab => {
                            this.props.history.push(`/group/${this.props.match.params.id}/${selectedTab}`)
                        }} >
                        <Tab name="nodebooks" title="Nodebooks">
                            <div className="container-fluid">
                                <div className="row">
                                    {
                                        (this.state.nodebooks.length!==0)
                                            ? this.state.nodebooks.map(ndbk => <PreviewNodebook key={ndbk.id} info={ndbk} />)
                                            :   ((this.state.info.permissions!=='admin')
                                                    ? <div className="col-lg-12"><p>No nodebooks to display.</p></div>
                                                    : null
                                                )
                                    }
                                    {
                                    // Add new nodebook
                                    (this.state.info.permissions==='admin')
                                        ? <AddNewNodebook createNodebook={this.createNodebook} />
                                        : null
                                    }
                                </div>
                            </div>
                        </Tab>
                        <Tab name="members" title="Members">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <PermissionsManager
                                            isGroupPage
                                            users={this.state.users}
                                            currentUser={this.props.auth.user}
                                            permissions={this.state.info.permissions}
                                            authLevel={authLevel}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    </Tabs>

                </div>

            </div>
        );
    }
}

export default withRouter(GroupPage);



// WEBPACK FOOTER //
// ./src/components/GroupPage.js